// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup

/**
 * Module-level latch, keyed on the experiment name and never reset: set when this page load applies the
 * arm (with the treat and `$exposure`, or for an override), so a remount of the footer keeps the arm and
 * does not treat or expose again. It resets on a full reload; from then on the
 * exposure cap in localStorage (with consent) is what keeps a signer from being exposed again.
 */
export const featuredTreats = new Map<string, Promise<void>>();
